<form [formGroup]="form">
  <div class="warehouse-group-popup_wrapper">
    <h3>{{ mode }} Warehouse Group</h3>
    <div class="form-group">
      <label class="lum-label">Label</label>
      <input type="text" class="lum-input" matInput formControlName="label" />
    </div>
    <div class="form-group">
      <label class="lum-label">Description</label>
      <input type="text" class="lum-input" matInput formControlName="description" />
    </div>
    <div class="form-group">
      <label class="lum-label">Warehouses</label>

      <mat-select
        class="warehouse-select_wrapper lum-select"
        multiple
        [compareWith]="compareWarehouses"
        [(ngModel)]="selectedWarehouses"
        [ngModelOptions]="{ standalone: true }"
        (selectionChange)="onWarehouseSelect()"
      >
        <mat-option
          *ngFor="let warehouse of warehouses; trackBy: trackById"
          [value]="warehouse"
          >{{ warehouse?.location_name }}</mat-option
        >
      </mat-select>
    </div>
    <div class="form-group">
      <label class="lum-label">Default Picking Warehouse</label>
      <mat-select
        class="warehouse-select_wrapper lum-select"
        formControlName="defaultWarehouseId"
        [disabled]="!selectedWarehouses.length"
      >
        <mat-option
          *ngFor="let warehouse of selectedWarehouses; trackBy: trackById"
          [value]="warehouse.id"
          >{{ warehouse?.location_name }}</mat-option
        >
      </mat-select>
    </div>
    <div class="form-group" *ngIf="ftPickAndPackEnabled && !isEnableExteralManage">
      <label class="lum-label">Warehouse Group Pick and Pack</label>
      <div class="form-group form-inline">
        <mat-select
          class="warehouse-select_wrapper lum-select"
          formControlName="pickAndPackEnabled"
        >
          <mat-option [value]="false">{{
            ePickAndPackEnabledValue.AUTOMATIC
          }}</mat-option>
          <mat-option [value]="true"
            >{{ ePickAndPackEnabledValue.MANUAL }}
          </mat-option>
        </mat-select>
      </div>
      <small *ngIf="form.get('pickAndPackEnabled')?.value">
        This is when it's turned on. This requires an action within Luminous for the
        inventory to be removed.
      </small>
      <small *ngIf="!form.get('pickAndPackEnabled')?.value">
        This will automatically deduct inventory when the OMS updates the status to
        shipped.
      </small>
    </div>
    <div
      class="form-group"
      *ngIf="
        'red_DV-3094_multiple_warehouses_on_different_warehouse_groups'
          | featureFlag
      "
    >
      <mat-slide-toggle formControlName="combineKitInventory">
        Combine Warehouse Group Inventory for KITs
      </mat-slide-toggle>
    </div>
    <div class="form-group" *ngIf="!isEnableExteralManage">
      <label class="lum-label">Scan to Verify Picklist Orders</label>
      <mat-slide-toggle formControlName="scanToVerify">
        <span class="text-small">
          Require verifying picklist order packed items before shipping
        </span>
      </mat-slide-toggle>
    </div>
    <div class="externally-manage-options">
      <div class="form-group">
        <mat-checkbox color="primary" formControlName="externallyManaged">
          Externally Managed
        </mat-checkbox>
      </div>
      <ng-container *ngIf="isEnableExteralManage">
        <div class="form-group">
          <mat-checkbox
            color="primary"
            formControlName="calculateKitQuantities"
            matTooltip="Determines whether kit quantities should be calculated for this warehouse group, even if it's externally managed."
            matTooltipPosition="above"
          >
            Calculate Kit Quantities
          </mat-checkbox>
        </div>

        <div class="form-group">
          <label class="lum-label" for="">App Integration Account</label>
          <lum-ui-autocomplete
            [placeholder]="'Search Account...'"
            [options]="appIntegrationAccounts || []"
            [debounceTime]="500"
            [loading]="loadingAppIntegrationAccounts"
            [displayProperty]="'label'"
            [value]="selectedExternallyManagedAppIntegrationAccountId?.label"
            (inputChangeEvent)="onSearchAppIntegrationAccounts($event)"
            (optionSelectedEvent)="onSelectAppIntegrationAccountEvent($event)"
            (scrollPaginate)="onLazyLoadAppIntegrationAccount()"
            class="input-box"
          ></lum-ui-autocomplete>
        </div>

        <div *ngIf="!isEdi" class="form-group">
          <label class="lum-label" for="">External Warehouse</label>
          <lum-external-warehouse-control
            formControlName="appIntegrationAccountInventoryLocation"
            [queryParams]="{
              appIntegrationAccountId: form.get(
                'externallyManagedAppIntegrationAccountId'
              ).value,
            }"
            [disabled]="!form.get('externallyManagedAppIntegrationAccountId').value"
          ></lum-external-warehouse-control>
        </div>
        <ng-container *ngIf="isEdi">
          <ng-container *ngIf="data?.warehouseGroup; else webhookUrlWhenCreating">
            <div class="form-group">
              <label class="lum-label" for="">Webhook URL</label>
              <div class="d-flex gap-x-2 align-items-stretch">
                <input
                  type="text"
                  class="lum-input form-control-plaintext"
                  readonly
                  [value]="webhookUrl"
                />
                <button
                  type="button"
                  class="
                    lum-button lum-button--secondary lum-button--square lum-button--large
                  "
                  [cdkCopyToClipboard]="webhookUrl"
                  (cdkCopyToClipboardCopied)="handleWebhookCopied($event)"
                  title="Copy to Clipboard"
                  >Copy</button
                >
              </div>
            </div>
          </ng-container>
          <ng-template #webhookUrlWhenCreating>
            <div class="form-group">
              <label class="lum-label" for="">Webhook URL</label>
              <p class="text-cloud-600">
                Webhook URL will be generated after this warehouse group is
                successfully created.
              </p>
            </div>
          </ng-template>
        </ng-container>
        <div class="flex gap-4">
          <mat-slide-toggle
            *ngIf="selectedAppIntegrationAccount?.supportsPullStocks"
            formControlName="pullStocks"
          >
            Pull Stocks
          </mat-slide-toggle>
          <mat-slide-toggle
            *ngIf="selectedAppIntegrationAccount?.supportsPullInboundShipments"
            formControlName="pullShipments"
          >
            Pull Shipments
          </mat-slide-toggle>
        </div>
      </ng-container>
    </div>
    <div class="flex justify-end mt-8">
      <lum-ui-button
        label="Cancel"
        type="secondary"
        class="mr-5"
        (click)="dialogRef.close()"
      ></lum-ui-button>
      <lum-ui-button
        label="Submit"
        type="primary"
        (click)="onSubmit()"
        [loading]="(submittingForm$ | async) || false"
      ></lum-ui-button>
    </div>
  </div>
</form>
